export const FETCH_ACCESS_DEVICE_REQUEST = 'FETCH_ACCESS_DEVICE_REQUEST';
export const FETCH_ACCESS_DEVICE_SUCCESS = 'FETCH_ACCESS_DEVICE_SUCCESS';
export const FETCH_ACCESS_DEVICE_FAILED = 'FETCH_ACCESS_DEVICE_FAILED';
export const FETCH_ACCESS_DEVICE_BY_ID_REQUEST = 'FETCH_ACCESS_DEVICE_BY_ID_REQUEST';
export const FETCH_ACCESS_DEVICE_BY_ID_SUCCESS = 'FETCH_ACCESS_DEVICE_BY_ID_SUCCESS';
export const FETCH_ACCESS_DEVICE_BY_ID_FAILED = 'FETCH_ACCESS_DEVICE_BY_ID_FAILED';
export const CREATE_ACCESS_DEVICE_REQUEST = 'CREATE_ACCESS_DEVICE_REQUEST';
export const CREATE_ACCESS_DEVICE_SUCCESS = 'CREATE_ACCESS_DEVICE_SUCCESS';
export const CREATE_ACCESS_DEVICE_FAILED = 'CREATE_ACCESS_DEVICE_FAILED';
export const UPDATE_ACCESS_DEVICE_REQUEST = 'UPDATE_ACCESS_DEVICE_REQUEST';
export const UPDATE_ACCESS_DEVICE_SUCCESS = 'UPDATE_ACCESS_DEVICE_SUCCESS';
export const UPDATE_ACCESS_DEVICE_FAILED = 'UPDATE_ACCESS_DEVICE_FAILED';
export const DELETE_ACCESS_DEVICE_REQUEST = 'DELETE_ACCESS_DEVICE_REQUEST';
export const DELETE_ACCESS_DEVICE_SUCCESS = 'DELETE_ACCESS_DEVICE_SUCCESS';
export const DELETE_ACCESS_DEVICE_FAILED = 'DELETE_ACCESS_DEVICE_FAILED';
export const ASSIGN_ACCESS_DEVICE_REQUEST = 'ASSIGN_ACCESS_DEVICE_REQUEST';
export const ASSIGN_ACCESS_DEVICE_SUCCESS = 'ASSIGN_ACCESS_DEVICE_SUCCESS';
export const ASSIGN_ACCESS_DEVICE_FAILED = 'ASSIGN_ACCESS_DEVICE_FAILED';
export const UNASSIGN_ACCESS_DEVICE_REQUEST = 'UNASSIGN_ACCESS_DEVICE_REQUEST';
export const UNASSIGN_ACCESS_DEVICE_SUCCESS = 'UNASSIGN_ACCESS_DEVICE_SUCCESS';
export const UNASSIGN_ACCESS_DEVICE_FAILED = 'UNASSIGN_ACCESS_DEVICE_FAILED';
export const RESET_ACCESS_DEVICE_STATE = 'RESET_ACCESS_DEVICE_STATE';
export const RESET_ACCESS_DEVICE = 'RESET_ACCESS_DEVICE';
export const FETCH_ADD_BROKER_REQUEST = 'FETCH_ADD_BROKER_REQUEST';
export const FETCH_ADD_BROKER_SUCCESS = 'FETCH_ADD_BROKER_SUCCESS';
export const FETCH_ADD_BROKER_FAILED = 'FETCH_ADD_BROKER_FAILED';
export const FETCH_REMOVE_BROKER_REQUEST = 'FETCH_REMOVE_BROKER_REQUEST';
export const FETCH_REMOVE_BROKER_SUCCESS = 'FETCH_REMOVE_BROKER_SUCCESS';
export const FETCH_REMOVE_BROKER_FAILED = 'FETCH_REMOVE_BROKER_FAILED';
